"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Sensor = require("@meepshop/context/lib/Sensor");

var _link = _interopRequireDefault(require("../link"));

var Logo = function Logo(_ref) {
  var logo = _ref.logo,
      height = _ref.height,
      width = _ref.width,
      storeName = _ref.storeName;

  var _useSensorContext = (0, _Sensor.useSensorContext)(),
      isDesktop = _useSensorContext.isDesktop;

  if (isDesktop) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      src: logo || require("@meepshop/images/lib/getImage")["default"]({
        stage: "https://img.meepstage.com/hb13OmlOSdeWG3iDm7QOqQ4UBbE-Q9Q99FU2uCWLIY4/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvbG9nb0Rlc2t0b3BEZWZhdWx0LnN2Zw.svg",
        production: "https://img.meepshop.com/JOZarog-wPW9RBPxUI38hvY75BJcct3Z4UyMGiu6Q3c/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvbG9nb0Rlc2t0b3BEZWZhdWx0LnN2Zw.svg"
      }),
      style: {
        height: '48px'
      },
      alt: "logoDesktopDefault"
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_link["default"], {
    style: {
      width: '100%'
    },
    href: "/",
    target: "_self"
  }, !logo ? null : /*#__PURE__*/_react["default"].createElement("img", {
    loading: "eager",
    style: {
      height: height !== 0 ? height : undefined,
      // height: 48,
      width: width !== 0 ? width : undefined,
      objectFit: height && width ? 'contain' : undefined
    },
    src: "".concat(logo, "?").concat(width ? "w=".concat(width * 3) : "h=".concat(height * 3)),
    srcSet: "".concat(logo, "?").concat(width ? "w=".concat(width) : "h=".concat(height), " 1x, ").concat(logo, "?").concat(width ? "w=".concat(width * 2) : "h=".concat(height * 2), " 2x, ").concat(logo, "?").concat(width ? "w=".concat(width * 3) : "h=".concat(height * 3), " 3x"),
    alt: storeName
  }));
};

var _default = Logo;
exports["default"] = _default;